export const STANDARD_REGEX = {
    domainName: new RegExp(
        /^(?:[a-zA-Z0-9][a-zA-Z0-9-]{0,61}\.)+[a-zA-Z0-9]{2,}$/
    ),
};
